import { render, staticRenderFns } from "./ExpansionHeader.vue?vue&type=template&id=98b0a40c&"
import script from "./ExpansionHeader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ExpansionHeader.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports